import React, { useEffect, useMemo, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isEmpty } from "lodash";
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import PageHint from '../../../components/Common/PageHint';
import DeleteModal from '../../../components/Common/DeleteModal';
import LangModal from '../../../components/Common/LangModal';

import {
  deleteSlider as onDeleteSlider,
  addSlider as onAddSlider,
  updateSlider as onUpdateSlider,
  getSlider as onGetSlider,
} from "store/contacts/actions";

import {
  Name,
  Status
}
  from "./EcommerceOrderCol";
  import 'react-dropzone-uploader/dist/styles.css'
  import Dropzone from 'react-dropzone-uploader';

//redux
import { useSelector, useDispatch } from "react-redux";
import EcommerceOrdersModal from "./EcommerceOrdersModal";

import "toastr/build/toastr.min.css";

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from "reactstrap";
import { makeUploadParams } from "../../../helpers/imageResize";

function EcommerceOrder() {

  //meta title
  document.title = "Slider | BUHARA - Admin Paneli";

  const [getIsActive, setIsActive] = useState(false);
  const [getFileNameBanner, setFileNameBanner] = useState(null);
  const  [getFileNameMobile, setFileNameMobile] = useState(null);

  // Görseller sunucuya gitmeden önce tarayıcıda küçültülür (helpers/imageResize).
  const getUploadParams = makeUploadParams('https://buharaadmin.stechomeyazilim.info:8099/uploadfile');
   
  // handle the status of the file upload
  const handleChangeStatusBanner = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileNameBanner(result.file.filename)

        }
      }
    }
  }

    // handle the status of the file upload
    const handleChangeStatusMobile = ({ xhr }) => {
      if (xhr) {
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            const result = JSON.parse(xhr.response);
            setFileNameMobile(result.file.filename)
  
          }
        }
      }
    }
  

  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [orderList, setOrderList] = useState([]);
  const [order, setOrder] = useState(null);
  const [getEditSlider, setEditSlider] = useState(null);
  const [langModal, setLangModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (getEditSlider && getEditSlider.Slider_Text) || '',
      link: (getEditSlider && getEditSlider.Slider_Link) || '',
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Başlığı Giriniz"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        const updateSlider = {
          ID: order ? order.ID : 0,
          Slider_Text: values.title,
          SliderImage: getFileNameBanner,
          Slider_Active : getIsActive,
          Slider_MobilePhoto :getFileNameMobile,
          Slider_Link: values.link,
        };
        // update order
        dispatch(onUpdateSlider(updateSlider));
        validation.resetForm();
      } else {
        const newOrder = {
          Slider_Text: values["title"],
          SliderImage: getFileNameBanner,
          Slider_Active : getIsActive,
          Slider_MobilePhoto : getFileNameMobile,
           Slider_Link: values["link"],
        };
        // save new order
        dispatch(onAddSlider(newOrder));
        validation.resetForm();
      }
      toggle();
    },
  });


  const toggleViewModal = () => setModal1(!modal1);

  const dispatch = useDispatch();
  const { orders } = useSelector(state => ({
    orders: state.contacts.slider,
  }));

  useEffect(() => {
   if (orders && !orders.length) {
      dispatch(onGetSlider());
    }
  }, [dispatch, orders]);

  useEffect(() => {
    setOrderList(orders);
  }, [orders]);

  useEffect(() => {
    if (!isEmpty(orders) && !!isEdit) {
      setOrderList(orders);
      setIsEdit(false);
    }
  }, [orders]);

  const toggle = () => {
    if (modal) {
      setModal(false);
      setOrder(null);
    } else {
      setModal(true);
    }
  };

  const handleOrderClick = arg => {
    const order = arg;
    setEditSlider(order)
    setOrder(order);
    setIsEdit(true);

    setFileNameMobile(order.Slider_MobilePhoto)
    setFileNameBanner(order.SliderImage)
    setIsActive(order.Slider_Active)
    toggle();
  };

  //delete order
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (order) => {
    setOrder(order);
    setDeleteModal(true);
  };

  const handleDeleteOrder = () => {
    console.log("şsdmfşl",order)
    if (order && order.ID) {
      dispatch(onDeleteSlider(order.ID));
      setDeleteModal(false);
    }
  };
  const handleOrderClicks = () => {
    setOrderList("");
    setIsEdit(false);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        Header: 'BAŞLIK',
        accessor: 'Slider_Text',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          return <Name {...cellProps} />;
        }
      },
      {
        Header: "Görsel",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.SliderImage ? (
              <div className="avatar-xl">
               {cellProps.Slider_Text != null ? <span className="avatar-title rounded-circle">
                  {cellProps.Slider_Text.charAt(0)}
                </span> : null}
              </div>
            ) : (
              <div>
                <img
                  className=" avatar-xl"
                  src={'https://buharasubdomain.stechomeyazilim.info/' +  cellProps.SliderImage}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },
      {
        Header: "Mobil Görseli",
        // accessor: "name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <>
            {!cellProps.Slider_MobilePhoto ? (
              <div className="avatar-xl">
                {cellProps.Slider_Text != null ? <span className="avatar-title rounded-circle">
                  {cellProps.Slider_Text.charAt(0)}
                </span> : null }
              </div>
            ) : (
              <div>
                <img
                  className="avatar-xl"
                  src={'https://buharasubdomain.stechomeyazilim.info/' + cellProps.Slider_MobilePhoto}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },
     
      {
        Header: 'Aktiflik Durumu',
        accessor: 'Slider_Active',
        disableFilters: true,
        filterable: true,
        Cell: (cellProps) => {
          return <Status {...cellProps} />;
        }
      },
      {
        Header: 'İşlemler',
        accessor: 'action',
        disableFilters: true,
        Cell: (cellProps) => {
          return (
            <div className="d-flex gap-3">
              <Link
                to="#"
                className="text-success"
                onClick={() => {
                  const orderData = cellProps.row.original;
                  handleOrderClick(orderData);
                }}
              >
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">
                  Düzenle
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-info"
                onClick={() => {
                  setSelectedItem(cellProps.row.original);
                  setLangModal(true);
                }}
              >
                <i className="mdi mdi-translate font-size-18" id="langtooltip-slider" />
                <UncontrolledTooltip placement="top" target="langtooltip-slider">
                  Çeviriler
                </UncontrolledTooltip>
              </Link>
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const orderData = cellProps.row.original;
                  onClickDelete(orderData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        }
      },
    ],
    []
  );

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }

  return (
    <React.Fragment>
      <EcommerceOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      <LangModal
        isOpen={langModal}
        toggle={() => setLangModal(false)}
        sourceRecord={selectedItem}
        title="Slider"
        tableName="Slider_Lang"
        foreignKey="Slider_ID"
        foreignKeyValue={selectedItem?.ID}
        fields={[
          { name: 'SliderImage', label: 'Görsel', type: 'image' },
          { name: 'Slider_Text', label: 'Başlık', type: 'text' },
          { name: 'Slider_Link', label: 'Link', type: 'text' },
        ]}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteOrder}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Yönetim" breadcrumbItem="Slider" />
          <PageHint
            what="Anasayfanın üstündeki görsel şerit bu ekrandan yönetilir."
            where="Anasayfa açılır açılmaz görünen büyük slider. Her dil için ayrı görsel ve metin verilebilir."
            note="Mobil uygulamanın slider’ı ayrı ekranda: “Slider (Mobil)”."
            links={[{ label: 'Anasayfa', path: '/anasayfa' }]}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={orders}
                    isGlobalFilter={true}
                    isAddSlider={true}
                    handleOrderClicks={handleOrderClicks}
                    customPageSize={10}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Slider Düzenle" : "Slider Ekle"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >

<div className="mb-3">
                      <Label className="form-label">Başlık</Label>
                      <Input
                        name="title"
                        type="text"
                        placeholder="Başlık"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.title || ""}
                        invalid={
                          validation.touched.title && validation.errors.title ? true : false
                        }
                      />
                      {validation.touched.title && validation.errors.title ? (
                        <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                      ) : null}
                    </div>
                  


<div className="mb-3">
                      <Label className="form-label">Link</Label>
                      <Input
                        name="link"
                        type="text"
                        placeholder="Link"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.link || ""}
                        invalid={
                          validation.touched.link && validation.errors.link ? true : false
                        }
                      />
                      {validation.touched.link && validation.errors.link ? (
                        <FormFeedback type="invalid">{validation.errors.link}</FormFeedback>
                      ) : null}
                    </div>
                 
               

                <Row>
                <Col xs={12} className="mb-3">
                            <label htmlFor="resume">Web Görseli(800*600)</label>
                         <Dropzone
          getUploadParams={getUploadParams}
          onChangeStatus={handleChangeStatusBanner}
          maxFiles={1}
          styles={{
            dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
            inputLabelWithFiles: { margin: '20px 3%' }
          }}
          canRemove={false}
          PreviewComponent={Preview}
          accept="image/*"
        />
                
                          </Col>
                </Row>

                <Row>
                <Col xs={12} className="mb-3">
                            <label htmlFor="resume">Mobil Görseli(800*600)</label>
                         <Dropzone
          getUploadParams={getUploadParams}
          onChangeStatus={handleChangeStatusMobile}
          maxFiles={1}
          styles={{
            dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
            inputLabelWithFiles: { margin: '20px 3%' }
          }}
          canRemove={false}
          PreviewComponent={Preview}
          accept="image/*"
        />
                
                          </Col>
                </Row>
             

              <div className="d-flex">
                
              {getFileNameBanner != null ?   <Row>
                <label htmlFor="resume">Web Mevcut Eklenen Resim</label>

                <Col xs={12} className="mb-3">
                            <img
                  className=" avatar-xl"
                  src={'https://buharasubdomain.stechomeyazilim.info/' +  getFileNameBanner}
                  alt=""
                />
                          </Col>
                </Row> : null}

               { getFileNameMobile != null ?
                <Row>
                <label htmlFor="resume">Mobil Mevcut Eklenen Resim</label>

                <Col xs={12} className="mb-3">
                            <img
                  className=" avatar-xl"
                  src={'https://buharasubdomain.stechomeyazilim.info/' +  getFileNameMobile}
                  alt=""
                />
                          </Col>
                </Row> : null}
                </div>

                <div className="square-switch">
                            <input
                              type="checkbox"
                              id="square-switch1"
                              className="switch"
                              defaultChecked={getIsActive}
                              onChange={() =>
                                setIsActive(!getIsActive)
                              }
                            />
                            <label
                         htmlFor="square-switch1"
                              data-on-label="Aktif "
                              data-off-label="Pasif"
                            />
                          </div>

                <Row>
                  <Col>
                    <div className="text-end">
                      <button
                        type="submit"
                        className="btn btn-success save-user"
                      >
                        Kaydet
                      </button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  );
}
EcommerceOrder.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default EcommerceOrder;